export function isValueEmpty<Value>(value?: Value[]): boolean {
  return Boolean(!value || value.length === 0);
}
